export const headerData = {
    logoImage: "https://res2.weblium.site/res/5fed3c09cf52350021e8c7d0/5ff9430911f1f00022366bda?nowebp",
    labels: [
        {
            label: "Home",
            path: "/"
        },
        {
            label: "About",
            path: "about"
        },
        {
            label: "Products",
            path: "products"
        }], 
}